<template>
  <v-dialog
      v-model="showEventForm"
      persistent
      scrollable
      max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">
          {{ currentItem.id ? "Update event" : "Create event" }}
        </span>
      </v-card-title>
      <v-card-text class="py-0 event-editor">
        <v-form ref="form" lazy-validation>
          <v-container>
            <v-text-field v-model="event.id" class="d-none"></v-text-field>
            <span>Display name</span>
            <br/>
            <small>This is the display name of the event</small>
            <v-text-field outlined dense :rules=formRules.required v-model="event.title"></v-text-field>
            <span>Value</span>
            <br/>
            <small>This is the value to handle the event</small>
            <v-text-field outlined dense :rules=formRules.required v-model="event.value"></v-text-field>
            <span>Example</span>
            <br/>
            <small>Here is an example of event data</small>
            <v-textarea outlined dense :rules=formRules.required v-model="event.example"></v-textarea>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
            depressed
            class="text-none"
            @click="cancel"
        >
          Hủy
        </v-btn>
        <v-btn
            color="primary"
            depressed
            class="text-none"
            @click="submit"
        >
          {{ currentItem.id ? "Update" : "Create" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {sync} from "vuex-pathify";
import FormMixin from "@/mixins/form.mixin"
import {mapActions} from "vuex";

export default {
  name: "EventForm",
  mixins: [FormMixin],
  data() {
    return {
      event: {
        id: "",
        title: "",
        value: "",
        example: ""
      }
    }
  },
  computed: {
    showEventForm: sync('dialogs/showEventForm'),
    currentItem: sync('event/currentItem')
  },
  methods: {
    ...mapActions('event', ['create', 'update']),
    submit() {
      if (this.$refs.form.validate()) {
        if (!this.event.id) {
          this.create(this.event)
        } else {
          this.update(this.event)
        }
        this.reset()
        this.currentItem = {}
      }
    },
    cancel() {
      this.reset()
      this.currentItem = {}
      this.showEventForm = false
    },
    reset() {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    }
  },
  watch: {
    currentItem: {
      handler() {
        if (this.currentItem.id) {
          this.event = {
            ...this.currentItem
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.event-editor::-webkit-scrollbar {
  display: none;
}
.event-editor {
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}
</style>
